
import Vue from 'vue';
import {useJobs} from '@/integrations/softgarden/src/composables/useJobs';
import {ssrRef, useContext, useRoute} from '@nuxtjs/composition-api';
import {onSSR} from '@vue-storefront/core';
import {applyMetaFromContent} from '@/helpers/storyblok/storyblok';
import jobPosting from '@/helpers/googleSchema/jobPosting';
import isApprenticeship from '~/helpers/jobs/isApprenticeship';
import jobAdTextTemplateByType from '@/helpers/jobs/jobAdTextTemplateByType';
import BaseButton from '@/components/BaseButton';

export default Vue.extend({
  name: 'JobDetail',
  components: {
    BaseButton,
  },
  props: {
    jobId: {
      type: String,
    },
    jobType: {
      type: String,
      default: 'job',
      validator: (value) => ['job', 'apprenticeship'].includes(value),
    },
    image: {
      type: Array,
    },
    video: {
      type: Object,
    },
    availableHeadline: {
      type: Array,
    },
    unavailableHeadline: {
      type: Array,
    },
  },
  setup() {
    const {
      jobs,
      searchJobById,
    } = useJobs(`JOB_DETAIL_${Date.now()}`);

    const {error} = useContext();

    const params = useRoute().value.params;

    const job = ssrRef({});

    onSSR(async () => {
      // Get job data from softgarden
      if(params.jobId) {
        await searchJobById(params.jobId);

        if (!jobs.value || Object.keys(jobs.value).length === 0 || (!isApprenticeship(jobs.value) && !jobs.value.applyStatus)) {
          error({ statusCode: 404 });
          return;
        }
      }

      job.value = jobs.value;
    });

    return {
      searchJobById,
      job,
      jobs,
    };
  },
  data() {
    return {
      showVideo: false,
      isActive: false,
      isLoading: true,
    };
  },
  head() {
    let meta = {
      title: null,
      meta: [],
      link: [],
    };

    // Apply meta info from storyblok page
    applyMetaFromContent(meta, this.content);

    if (this.job && this.job.externalPostingName) {
      meta.title = this.job.externalPostingName;
    }

    return {
      ...meta,
      script: [
        (this.job) ? {
          hid: 'googleTag',
          type: 'application/ld+json',
          innerHTML: jobPosting(this.job),
        } : {},
      ],
      __dangerouslyDisableSanitizersByTagID: {
        googleTag: ['innerHTML'],
      },
    };
  },
  async mounted() {
    if (this.isLoading && this?.job?.length <= 0 && this.jobId) {
      await this.searchJob();
      this.isLoading = false;
      this.job = this.jobs;
    }

  },
  methods: {
    async searchJob() {
      await this.searchJobById(this.jobId);
    },
    renderJobAdText() {
      if (!this.job || !this.job.jobAdText) {
        return '';
      }
      return jobAdTextTemplateByType(this.job.jobAdText, this.jobType);
    },
    toggleMedia() {
      this.showVideo = !this.showVideo;
      this.isActive = !this.isActive;

      this.$refs.video.currentTime = !this.showVideo ? 0 : this.$refs.video.currentTime;
    },
  },
});
